/** 사이즈별 수량을 화면 사이에 잇는 쿼리 이름 — 상품 상세 → 커스터마이징 → 견적 요청이 같은 값을 넘긴다. */
export const SIZE_QUANTITIES_PARAM = 'sizes';

/** 사이즈 옵션 id → 수량(1 이상 정수). 0 이나 빈칸인 사이즈는 담지 않는다. */
export type SizeQuantities = Readonly<Record<string, number>>;

const ID_PATTERN = /^[0-9A-Za-z-]{1,64}$/;
const QTY_PATTERN = /^[1-9][0-9]{0,8}$/;

/** `id:수량,id:수량` 쿼리 값 — 담을 사이즈가 없으면 null(쿼리를 붙이지 않는다). */
export const formatSizeQuantities = (sizes: SizeQuantities | null | undefined): string | null => {
  if (!sizes) return null;
  const parts = Object.entries(sizes)
    .filter(([id, qty]) => ID_PATTERN.test(id) && Number.isSafeInteger(qty) && qty > 0)
    .map(([id, qty]) => `${id}:${qty}`);
  return parts.length === 0 ? null : parts.join(',');
};

/**
 * 쿼리 값을 읽는다 — 손으로 고친 주소일 수 있어 형식이 맞는 조각만 담고 나머지는 버린다. 어느 사이즈가 그 상품 것인지는
 * 받는 화면이 사이즈 옵션과 맞춰 본다.
 */
export const parseSizeQuantities = (raw: string | null): SizeQuantities => {
  if (raw === null || raw === '') return {};
  const entries: [string, number][] = [];
  for (const part of raw.split(',')) {
    const [id, qty, ...rest] = part.split(':');
    if (rest.length > 0 || id === undefined || qty === undefined) continue;
    if (!ID_PATTERN.test(id) || !QTY_PATTERN.test(qty)) continue;
    entries.push([id, Number(qty)]);
  }
  return Object.fromEntries(entries);
};
